module.exports = __webpack_public_path__ + "8a0202aed6429faf059f77a479b75bef.ttf";